<template>
    <Modal v-model:show="show">
        <template #header>
            <div class="modal-header-container">
                <h5 class="modal-title">{{ $t('content.uploads.send_media') }}</h5>
                <div id="upload-dropzone-modal_w">
                    <p>{{ $t('content.uploads.warning') }}</p>
                    <p>{{ $t('content.uploads.max_size') }}</p>
                </div>
            </div>
        </template>
        <UploadDropzone
            v-if="show"
            v-model="files"
            @success="$emit('success', $event)"
        ></UploadDropzone>
    </Modal>
</template>

<script>
import Modal from '../../../argon/components/Modal';
import UploadDropzone from './UploadDropzone';

export default {
    emits: ['close', 'input', 'success', 'update:modelValue'],
    name: 'UploadDropzoneModal',

    components: {
        Modal,
        UploadDropzone,
    },

    props: {
        modelValue: [], // eslint-disable-line object-shorthand
        modal: [Boolean, Number],
    },

    computed: {
        files: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            },
        },
        show: {
            get() {
                return this.modal;
            },
            set(value) {
                this.$emit('close', value);
            },
        },
    },
};
</script>


<style scoped>
.modal-header-container { /* Estilo para o novo contêiner */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

/* Outros estilos permanecem iguais */
#upload-dropzone-modal_w {
    font-size: 10px;
    color: #ff0000; /* Vermelho para destacar a mensagem */
}
</style>
